import { css } from 'lit';

export const publicSectionStyles = css`
  .section-head {
    text-align: center;
    margin: 0 0 2.1rem;
  }
  .tag {
    font-size: var(--jv-fs-xs);
    color: var(--jv-color-accent);
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }
  .tag.dollar::before {
    content: '$ ';
  }
  .tag.hash::before {
    content: '# ';
  }
  .tag.tilde::before {
    content: '~ ';
  }
  .script {
    font-size: 0.95rem;
    color: var(--jv-color-amber);
    margin-bottom: 0.5rem;
  }
  .script::before {
    content: '// ';
  }
  .lede-center {
    text-align: center;
    color: var(--jv-color-muted);
    font-size: var(--jv-fs-sm);
    margin: -1.4rem 0 2rem;
  }
  h2.section-title {
    font-size: 1.65rem;
    margin: 0.4rem 0 0;
  }
  .cards {
    display: grid;
    gap: 1.15rem;
  }
  @media (min-width: 800px) {
    .cards.thirds {
      grid-template-columns: repeat(3, 1fr);
    }
    .cards.four {
      grid-template-columns: repeat(4, 1fr);
    }
  }
  .card-title {
    font-family: var(--jv-font-display);
    font-size: 0.95rem;
    font-weight: 700;
    margin: 0;
  }
  .muted {
    margin: 0;
    color: var(--jv-color-muted);
    font-size: var(--jv-fs-sm);
  }
  .card-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.6rem;
    font-size: var(--jv-fs-xs);
    color: var(--jv-color-muted);
  }
  .price {
    font-weight: 700;
    color: var(--jv-color-accent);
    font-size: 0.85rem;
  }
  a.plain {
    text-decoration: none;
    color: inherit;
  }
`;
